import React, { useRef } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';

const HandStory: React.FC = () => {
    const container = useRef<HTMLDivElement>(null);
    const handRef = useRef<HTMLDivElement>(null);
    const textRef = useRef<HTMLHeadingElement>(null);

    useGSAP(() => {
        // Initial State
        gsap.set([handRef.current, textRef.current], {
            opacity: 1,
            y: 0,
            rotation: 0
        });

        // Subtle Floating Animation
        gsap.to(handRef.current, {
            y: -15,
            rotation: 2,
            duration: 4,
            ease: "sine.inOut",
            yoyo: true,
            repeat: -1
        });

    }, { scope: container });

    return (
        <section ref={container} className="py-24 md:py-32 bg-[#FDFCFB] flex flex-col items-center justify-center relative overflow-hidden px-4 md:px-8 z-[20]">

            {/* Subtle Watermark 'G' */}
            <div className="absolute inset-0 pointer-events-none opacity-[0.04] flex items-center justify-center z-0">
                <span className="font-display text-[70vw] md:text-[40vw] font-black leading-none text-[#1C1C1C] select-none translate-y-[-10%]">G</span>
            </div>

            <div className="relative w-full max-w-5xl flex flex-col items-center justify-center z-10">

                {/* Soft Shadow Base */}
                <div className="absolute left-1/2 -translate-x-1/2 top-[15%] md:top-[20%] w-[250px] h-[60px] md:w-[500px] md:h-[120px] bg-black opacity-10 blur-[40px] md:blur-[60px] rounded-full"></div>

                {/* Artifact Wrapper */}
                <div ref={handRef} className="z-20 relative flex justify-center w-full mb-12 md:mb-16">
                    <div className="relative group">
                        {/* Main Cookie Bowl Image */}
                        <div className="w-56 h-72 md:w-64 md:h-[340px] bg-[#1C1C1C] rounded-[2rem] md:rounded-[2.5rem] shadow-[0_30px_70px_rgba(0,0,0,0.3)] overflow-hidden border border-white/10 -rotate-2 group-hover:rotate-0 transition-transform duration-1000">
                            <img
                                src="https://i.imgur.com/ggie0fy.jpeg"
                                className="w-full h-full object-cover"
                                alt="Signature Bowl"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                        </div>
                    </div>
                </div>

                {/* Main Content Area */}
                <div className="w-full text-center z-40">
                    {/* Reduced font size for desktop as requested */}
                    <h2 ref={textRef} className="font-display text-[14vw] md:text-[8vw] font-black uppercase text-[#1C1C1C] leading-[0.75] tracking-[-0.07em] select-none">
                        GRAV<span className="text-[#D97B8D]">ITY</span>
                    </h2>

                    <div className="flex justify-center mt-10 md:mt-12">
                        <button className="bg-[#1C1C1C] text-[#FDFCFB] flex items-center gap-6 px-12 md:px-16 py-5 md:py-6 rounded-full font-black uppercase tracking-[0.4em] text-[10px] md:text-[11px] shadow-[0_25px_60px_rgba(0,0,0,0.3)] hover:bg-[#D97B8D] hover:text-[#1C1C1C] transition-all group active:scale-95">
                            VISIT STUDIO
                            <svg className="group-hover:translate-x-2 transition-transform" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4"><path d="M5 12h14m-7-7l7 7-7 7" /></svg>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HandStory;
